import React from "react";
import { FlaskConical, Factory, Flag, Globe2 } from "lucide-react";

const stages = [
  {
    icon: FlaskConical,
    phase: "Phase 01",
    title: "Product Development",
    desc: "Patent-pending design refinement and final engineering validation with real-world trade trials.",
    status: "In Progress",
  },
  {
    icon: Factory,
    phase: "Phase 02",
    title: "Manufacturing",
    desc: "UK-based manufacturing partner selection, tooling and first production runs at scale.",
    status: "Next",
  },
  {
    icon: Flag,
    phase: "Phase 03",
    title: "UK Launch",
    desc: "Distribution through electrical wholesalers, direct trade sales and panel-builder partnerships.",
    status: "2026",
  },
  {
    icon: Globe2,
    phase: "Phase 04",
    title: "International Expansion",
    desc: "Rollout into EU markets, ANZ and North America via licensed distribution partners.",
    status: "2027+",
  },
];

export const Roadmap = () => {
  return (
    <section
      id="roadmap"
      data-testid="roadmap-section"
      className="relative py-24 md:py-36 border-t border-[#27272A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="label-eyebrow">08 / Future Vision</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tighter mt-4">
              From prototype to{" "}
              <span className="text-[#FF6B00]">global trade tool.</span>
            </h2>
          </div>
          <div className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-[#A1A1AA] max-w-xs">
            A clear, staged path from UK launch to international expansion —
            built for investors, wholesalers and the trade.
          </div>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-0 right-0 top-[44px] h-px bg-[#27272A]" />
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#27272A] border border-[#27272A]">
            {stages.map((s, i) => (
              <div
                key={s.title}
                data-testid={`roadmap-phase-${i + 1}`}
                className="bg-[#0A0A0A] p-7 md:p-8 flex flex-col gap-4 hover:bg-[#141414] transition-colors relative"
              >
                <div className="flex items-center justify-between">
                  <div className="w-11 h-11 grid place-items-center bg-[#1F1F1F] border border-[#27272A] rounded-sm relative z-10">
                    <s.icon
                      className="w-5 h-5 text-[#FF6B00]"
                      strokeWidth={2}
                    />
                  </div>
                  <span className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#FF6B00] px-2 py-1 border border-[#FF6B00]/30 bg-[#FF6B00]/5">
                    {s.status}
                  </span>
                </div>
                <div className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#A1A1AA]">
                  {s.phase}
                </div>
                <div className="font-display text-xl md:text-2xl tracking-tight leading-tight">
                  {s.title}
                </div>
                <p className="text-[#A1A1AA] text-sm leading-relaxed">
                  {s.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
